import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import AuthLayout from 'components/AuthLayout';
import ForgottenPasswordForm from './components/ForgottenPasswordForm';

const ForgottenPasswordScreen: FC = () => {
  const { t } = useTranslation();
  return (
    <AuthLayout title={t('auth.forgottenPassword.title')}>
      <ForgottenPasswordForm />
    </AuthLayout>
  );
};
export default ForgottenPasswordScreen;
